import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { DataList, Banner } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  constructor(private apiService: ApiService) {}

  list(view: string = ''): Observable<DataList<Banner>> {
    this.apiService.getUserPath();
    return this.apiService.get<DataList<Banner>>(`${this.apiService.userPath}carousels?view=${view}`).pipe();
  }
}
